import styled from 'styled-components';

export const Container = styled.div`
  position: absolute; /* Faz com independenete de qualquer coisa, o objeto vai sempre fica na posição definida */
  right: 0;
  top: 0;
  padding: 30px;
  overflow: hidden;
`;
